"use client";

// Contador animado del precio (`priceCount`, `pmCountEl()` del handoff) —
// cuenta de 0 al valor real en ~1s (ease cúbico) cuando la card entra en
// viewport, con un delay escalonado por card.
import { useEffect, useState } from "react";

export function PriceCountUp({ target, play, delay }: { target: number; play: boolean; delay: number }) {
  const [value, setValue] = useState(play ? target : 0);

  useEffect(() => {
    if (!play) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) { setValue(target); return; }
    const t0Timeout = setTimeout(() => {
      let raf: number;
      const start = performance.now();
      const dur = 1000;
      function frame(now: number) {
        const p = Math.min((now - start) / dur, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        setValue(Math.round(target * eased));
        if (p < 1) raf = requestAnimationFrame(frame);
      }
      raf = requestAnimationFrame(frame);
      return () => cancelAnimationFrame(raf);
    }, delay);
    return () => clearTimeout(t0Timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [play]);

  return <>{value}</>;
}
